import * as yup from "yup";

export const haqSchema = yup.object().shape({
  HAQTitle: yup.string().required("Title is required").trim(),
  HAQDescription: yup.string().required("Descriptiopn is required").trim(),
  HAQButton: yup.string().required("Button Title is required").trim(),
  });

